export const SCORE_KIND_THRESHOLDS = {
  WARNING_MAX: 60,
  INFO_MAX: 80,
} as const;

export const SCORE_KIND = {
  WARNING: 'warning',
  INFO: 'info',
  SUCCESS: 'success',
} as const;
